import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles.css';
import App from './routes/App.jsx';
import Intro from './routes/Intro.jsx';
import GameDev from './routes/GameDev.jsx';
import Fullstack from './routes/Fullstack.jsx';
import OtherDev from './routes/OtherDev.jsx';
import Blog from './routes/Blog.jsx';
import DevBlog from './routes/DevBlog.jsx';
import Contact from './routes/Contact.jsx';
import Resume from './routes/Resume.jsx';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Intro /> },
      { path: 'resume', element: <Resume /> },
      { path: 'game-dev', element: <GameDev /> },
      { path: 'fullstack', element: <Fullstack /> },
      { path: 'other-dev', element: <OtherDev /> },
      { path: 'blog', element: <Blog /> },
      { path: 'dev-blog/:category/:name', element: <DevBlog /> },
      { path: 'contact', element: <Contact /> }
    ]
  }
]);

const rootEl = document.getElementById('root');
createRoot(rootEl).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);


